import { render, staticRenderFns } from "./remarkOrder.vue?vue&type=template&id=9e3a0166&scoped=true"
import script from "./remarkOrder.vue?vue&type=script&lang=js"
export * from "./remarkOrder.vue?vue&type=script&lang=js"
import style0 from "./remarkOrder.vue?vue&type=style&index=0&id=9e3a0166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e3a0166",
  null
  
)

export default component.exports